import Products from "./ui";

export default Products;
